/* Autogenerated file. Do not edit manually. */
/* tslint:disable */

import { Contract, ContractFactory, ContractTransactionResponse, Interface } from 'ethers';
import type { Signer, ContractDeployTransaction, ContractRunner } from 'ethers';
import type { NonPayableOverrides } from '../../../common';
import type { FlmFunCore, FlmFunCoreInterface } from '../../../src/contracts/FlmFunCore';

const _abi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'EnforcedPause',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ExpectedPause',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidFacetAddress',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidInitialization',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NoEthToRecover',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NotInitializing',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    name: 'OwnableInvalidOwner',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'OwnableUnauthorizedAccount',
    type: 'error',
  },
  {
    inputs: [],
    name: 'TransferProcessingFailed',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'string',
        name: 'facetName',
        type: 'string',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'oldFacet',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newFacet',
        type: 'address',
      },
    ],
    name: 'FacetUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint64',
        name: 'version',
        type: 'uint64',
      },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Paused',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Unpaused',
    type: 'event',
  },
  {
    inputs: [],
    name: 'adminFacet',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'affiliateFacet',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'affiliateFeePercentage',
    outputs: [
      {
        internalType: 'uint24',
        name: 'percentage',
        type: 'uint24',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
    ],
    name: 'affiliates',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'wallet',
            type: 'address',
          },
          {
            internalType: 'bool',
            name: 'status',
            type: 'bool',
          },
          {
            internalType: 'uint32',
            name: 'id',
            type: 'uint32',
          },
          {
            internalType: 'bytes32',
            name: 'url',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'logoUrl',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'description',
            type: 'bytes32',
          },
        ],
        internalType: 'struct LibMarket.Affiliate',
        name: 'affiliate',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'affiliatesCount',
    outputs: [
      {
        internalType: 'uint32',
        name: 'count',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'autoTransferBeneficiary',
    outputs: [
      {
        internalType: 'address',
        name: 'beneficiary',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'autoTransferThreshold',
    outputs: [
      {
        internalType: 'uint256',
        name: 'threshold',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: 'marketId',
        type: 'uint32',
      },
    ],
    name: 'cancelMarket',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'title',
        type: 'bytes32',
      },
      {
        internalType: 'enum LibMarket.MarketType',
        name: 'marketType',
        type: 'uint8',
      },
      {
        internalType: 'bytes32',
        name: 'description',
        type: 'bytes32',
      },
      {
        internalType: 'uint24',
        name: 'feeBps',
        type: 'uint24',
      },
      {
        internalType: 'uint24[]',
        name: 'probBpsPerOutcome',
        type: 'uint24[]',
      },
      {
        internalType: 'uint256',
        name: 'endTime',
        type: 'uint256',
      },
      {
        internalType: 'uint184',
        name: 'minMarketPrediction',
        type: 'uint184',
      },
      {
        components: [
          {
            internalType: 'bytes32',
            name: 'title',
            type: 'bytes32',
          },
        ],
        internalType: 'struct LibMarket.OutcomeDetails[]',
        name: 'outcomeDetails',
        type: 'tuple[]',
      },
      {
        internalType: 'uint32',
        name: 'affiliateId',
        type: 'uint32',
      },
    ],
    name: 'createMarket',
    outputs: [
      {
        internalType: 'uint32',
        name: 'marketId',
        type: 'uint32',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: 'creatorId',
        type: 'uint32',
      },
    ],
    name: 'creatorAddressById',
    outputs: [
      {
        internalType: 'address',
        name: 'creatorAddress',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'creatorFacet',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'creatorAddress',
        type: 'address',
      },
    ],
    name: 'creators',
    outputs: [
      {
        components: [
          {
            internalType: 'uint32',
            name: 'creatorId',
            type: 'uint32',
          },
          {
            internalType: 'bytes32',
            name: 'nickname',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'streamUrl',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'description',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'metadataUri',
            type: 'bytes32',
          },
        ],
        internalType: 'struct LibMarket.Creator',
        name: 'creator',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'creatorsCount',
    outputs: [
      {
        internalType: 'uint32',
        name: 'count',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: 'pageSize',
        type: 'uint32',
      },
      {
        internalType: 'uint32',
        name: 'page',
        type: 'uint32',
      },
    ],
    name: 'getAllMarkets',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'creator',
            type: 'address',
          },
          {
            internalType: 'uint32',
            name: 'id',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'affiliateId',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'totalPredictionsCount',
            type: 'uint32',
          },
          {
            internalType: 'uint184',
            name: 'minPrediction',
            type: 'uint184',
          },
          {
            internalType: 'uint24',
            name: 'feeBps',
            type: 'uint24',
          },
          {
            internalType: 'uint8',
            name: 'winningOutcomeIndex',
            type: 'uint8',
          },
          {
            internalType: 'enum LibMarket.MarketStatus',
            name: 'status',
            type: 'uint8',
          },
          {
            internalType: 'enum LibMarket.MarketType',
            name: 'marketType',
            type: 'uint8',
          },
          {
            internalType: 'bytes32',
            name: 'title',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'description',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'startTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'endTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'completedAt',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'creatorFeesTotal',
            type: 'uint256',
          },
          {
            internalType: 'uint24[]',
            name: 'probBpsPerOutcome',
            type: 'uint24[]',
          },
          {
            internalType: 'uint256[]',
            name: 'totalPerOutcome',
            type: 'uint256[]',
          },
          {
            internalType: 'uint256[]',
            name: 'totalSharesPerOutcome',
            type: 'uint256[]',
          },
          {
            components: [
              {
                internalType: 'bytes32',
                name: 'title',
                type: 'bytes32',
              },
            ],
            internalType: 'struct LibMarket.OutcomeDetails[]',
            name: 'outcomeDetails',
            type: 'tuple[]',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'wallet',
                type: 'address',
              },
              {
                internalType: 'uint8',
                name: 'outcomeIndex',
                type: 'uint8',
              },
              {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
              },
            ],
            internalType: 'struct LibMarket.StakeDetails[]',
            name: 'stakeDetails',
            type: 'tuple[]',
          },
        ],
        internalType: 'struct LibMarket.Market[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        internalType: 'uint32',
        name: 'pageSize',
        type: 'uint32',
      },
      {
        internalType: 'uint32',
        name: 'page',
        type: 'uint32',
      },
    ],
    name: 'getAllPredictionsForUser',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'wallet',
            type: 'address',
          },
          {
            internalType: 'uint40',
            name: 'createdAt',
            type: 'uint40',
          },
          {
            internalType: 'uint32',
            name: 'marketId',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'predictionId',
            type: 'uint32',
          },
          {
            internalType: 'uint8',
            name: 'outcomeIndex',
            type: 'uint8',
          },
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'shares',
            type: 'uint256',
          },
        ],
        internalType: 'struct LibMarket.Prediction[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'onlyLive',
        type: 'bool',
      },
      {
        internalType: 'address',
        name: 'filterUser',
        type: 'address',
      },
    ],
    name: 'getCreatorActiveMarkets',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'creator',
            type: 'address',
          },
          {
            internalType: 'uint32',
            name: 'id',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'affiliateId',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'totalPredictionsCount',
            type: 'uint32',
          },
          {
            internalType: 'uint184',
            name: 'minPrediction',
            type: 'uint184',
          },
          {
            internalType: 'uint24',
            name: 'feeBps',
            type: 'uint24',
          },
          {
            internalType: 'uint8',
            name: 'winningOutcomeIndex',
            type: 'uint8',
          },
          {
            internalType: 'enum LibMarket.MarketStatus',
            name: 'status',
            type: 'uint8',
          },
          {
            internalType: 'enum LibMarket.MarketType',
            name: 'marketType',
            type: 'uint8',
          },
          {
            internalType: 'bytes32',
            name: 'title',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'description',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'startTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'endTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'completedAt',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'creatorFeesTotal',
            type: 'uint256',
          },
          {
            internalType: 'uint24[]',
            name: 'probBpsPerOutcome',
            type: 'uint24[]',
          },
          {
            internalType: 'uint256[]',
            name: 'totalPerOutcome',
            type: 'uint256[]',
          },
          {
            internalType: 'uint256[]',
            name: 'totalSharesPerOutcome',
            type: 'uint256[]',
          },
          {
            components: [
              {
                internalType: 'bytes32',
                name: 'title',
                type: 'bytes32',
              },
            ],
            internalType: 'struct LibMarket.OutcomeDetails[]',
            name: 'outcomeDetails',
            type: 'tuple[]',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'wallet',
                type: 'address',
              },
              {
                internalType: 'uint8',
                name: 'outcomeIndex',
                type: 'uint8',
              },
              {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
              },
            ],
            internalType: 'struct LibMarket.StakeDetails[]',
            name: 'stakeDetails',
            type: 'tuple[]',
          },
        ],
        internalType: 'struct LibMarket.Market[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
      {
        internalType: 'uint32',
        name: 'pageSize',
        type: 'uint32',
      },
      {
        internalType: 'uint32',
        name: 'page',
        type: 'uint32',
      },
      {
        internalType: 'address',
        name: 'filterUser',
        type: 'address',
      },
    ],
    name: 'getCreatorAllMarkets',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'creator',
            type: 'address',
          },
          {
            internalType: 'uint32',
            name: 'id',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'affiliateId',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'totalPredictionsCount',
            type: 'uint32',
          },
          {
            internalType: 'uint184',
            name: 'minPrediction',
            type: 'uint184',
          },
          {
            internalType: 'uint24',
            name: 'feeBps',
            type: 'uint24',
          },
          {
            internalType: 'uint8',
            name: 'winningOutcomeIndex',
            type: 'uint8',
          },
          {
            internalType: 'enum LibMarket.MarketStatus',
            name: 'status',
            type: 'uint8',
          },
          {
            internalType: 'enum LibMarket.MarketType',
            name: 'marketType',
            type: 'uint8',
          },
          {
            internalType: 'bytes32',
            name: 'title',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'description',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'startTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'endTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'completedAt',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'creatorFeesTotal',
            type: 'uint256',
          },
          {
            internalType: 'uint24[]',
            name: 'probBpsPerOutcome',
            type: 'uint24[]',
          },
          {
            internalType: 'uint256[]',
            name: 'totalPerOutcome',
            type: 'uint256[]',
          },
          {
            internalType: 'uint256[]',
            name: 'totalSharesPerOutcome',
            type: 'uint256[]',
          },
          {
            components: [
              {
                internalType: 'bytes32',
                name: 'title',
                type: 'bytes32',
              },
            ],
            internalType: 'struct LibMarket.OutcomeDetails[]',
            name: 'outcomeDetails',
            type: 'tuple[]',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'wallet',
                type: 'address',
              },
              {
                internalType: 'uint8',
                name: 'outcomeIndex',
                type: 'uint8',
              },
              {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
              },
            ],
            internalType: 'struct LibMarket.StakeDetails[]',
            name: 'stakeDetails',
            type: 'tuple[]',
          },
        ],
        internalType: 'struct LibMarket.Market[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: 'creatorId',
        type: 'uint32',
      },
    ],
    name: 'getCreatorDetailsById',
    outputs: [
      {
        components: [
          {
            internalType: 'uint32',
            name: 'creatorId',
            type: 'uint32',
          },
          {
            internalType: 'bytes32',
            name: 'nickname',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'streamUrl',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'description',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'metadataUri',
            type: 'bytes32',
          },
        ],
        internalType: 'struct LibMarket.Creator',
        name: 'creator',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
      {
        internalType: 'uint32',
        name: 'pageSize',
        type: 'uint32',
      },
      {
        internalType: 'uint32',
        name: 'page',
        type: 'uint32',
      },
      {
        internalType: 'address',
        name: 'filterUser',
        type: 'address',
      },
    ],
    name: 'getCreatorSettledMarkets',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'creator',
            type: 'address',
          },
          {
            internalType: 'uint32',
            name: 'id',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'affiliateId',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'totalPredictionsCount',
            type: 'uint32',
          },
          {
            internalType: 'uint184',
            name: 'minPrediction',
            type: 'uint184',
          },
          {
            internalType: 'uint24',
            name: 'feeBps',
            type: 'uint24',
          },
          {
            internalType: 'uint8',
            name: 'winningOutcomeIndex',
            type: 'uint8',
          },
          {
            internalType: 'enum LibMarket.MarketStatus',
            name: 'status',
            type: 'uint8',
          },
          {
            internalType: 'enum LibMarket.MarketType',
            name: 'marketType',
            type: 'uint8',
          },
          {
            internalType: 'bytes32',
            name: 'title',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'description',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'startTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'endTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'completedAt',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'creatorFeesTotal',
            type: 'uint256',
          },
          {
            internalType: 'uint24[]',
            name: 'probBpsPerOutcome',
            type: 'uint24[]',
          },
          {
            internalType: 'uint256[]',
            name: 'totalPerOutcome',
            type: 'uint256[]',
          },
          {
            internalType: 'uint256[]',
            name: 'totalSharesPerOutcome',
            type: 'uint256[]',
          },
          {
            components: [
              {
                internalType: 'bytes32',
                name: 'title',
                type: 'bytes32',
              },
            ],
            internalType: 'struct LibMarket.OutcomeDetails[]',
            name: 'outcomeDetails',
            type: 'tuple[]',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'wallet',
                type: 'address',
              },
              {
                internalType: 'uint8',
                name: 'outcomeIndex',
                type: 'uint8',
              },
              {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
              },
            ],
            internalType: 'struct LibMarket.StakeDetails[]',
            name: 'stakeDetails',
            type: 'tuple[]',
          },
        ],
        internalType: 'struct LibMarket.Market[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
    ],
    name: 'getCreatorSettledStats',
    outputs: [
      {
        internalType: 'uint256',
        name: 'settledMarketsCount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'totalVolume',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'totalCreatorFees',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'totalPredictions',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'lastActivityTimestamp',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'onlyLive',
        type: 'bool',
      },
    ],
    name: 'getCreatorsActiveMarketsCount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
    ],
    name: 'getCreatorsAllMarketsCount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
    ],
    name: 'getCreatorsSettledMarketsCount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: 'id',
        type: 'uint32',
      },
      {
        internalType: 'address',
        name: 'filterUser',
        type: 'address',
      },
    ],
    name: 'getMarket',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'creator',
            type: 'address',
          },
          {
            internalType: 'uint32',
            name: 'id',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'affiliateId',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'totalPredictionsCount',
            type: 'uint32',
          },
          {
            internalType: 'uint184',
            name: 'minPrediction',
            type: 'uint184',
          },
          {
            internalType: 'uint24',
            name: 'feeBps',
            type: 'uint24',
          },
          {
            internalType: 'uint8',
            name: 'winningOutcomeIndex',
            type: 'uint8',
          },
          {
            internalType: 'enum LibMarket.MarketStatus',
            name: 'status',
            type: 'uint8',
          },
          {
            internalType: 'enum LibMarket.MarketType',
            name: 'marketType',
            type: 'uint8',
          },
          {
            internalType: 'bytes32',
            name: 'title',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'description',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'startTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'endTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'completedAt',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'creatorFeesTotal',
            type: 'uint256',
          },
          {
            internalType: 'uint24[]',
            name: 'probBpsPerOutcome',
            type: 'uint24[]',
          },
          {
            internalType: 'uint256[]',
            name: 'totalPerOutcome',
            type: 'uint256[]',
          },
          {
            internalType: 'uint256[]',
            name: 'totalSharesPerOutcome',
            type: 'uint256[]',
          },
          {
            components: [
              {
                internalType: 'bytes32',
                name: 'title',
                type: 'bytes32',
              },
            ],
            internalType: 'struct LibMarket.OutcomeDetails[]',
            name: 'outcomeDetails',
            type: 'tuple[]',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'wallet',
                type: 'address',
              },
              {
                internalType: 'uint8',
                name: 'outcomeIndex',
                type: 'uint8',
              },
              {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
              },
            ],
            internalType: 'struct LibMarket.StakeDetails[]',
            name: 'stakeDetails',
            type: 'tuple[]',
          },
        ],
        internalType: 'struct LibMarket.Market',
        name: 'market',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'initialOwner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_adminFacet',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_affiliateFacet',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_creatorFacet',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_marketFacet',
        type: 'address',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'lowestPossibleOdds',
    outputs: [
      {
        internalType: 'uint24',
        name: 'odds',
        type: 'uint24',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'marketFacet',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'marketsCount',
    outputs: [
      {
        internalType: 'uint32',
        name: 'count',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'maxFees',
    outputs: [
      {
        internalType: 'uint24',
        name: 'fees',
        type: 'uint24',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'maxMarketsPerCreator',
    outputs: [
      {
        internalType: 'uint32',
        name: 'maxMarkets',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'maxTime',
    outputs: [
      {
        internalType: 'uint24',
        name: 'maxTimeValue',
        type: 'uint24',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'minFees',
    outputs: [
      {
        internalType: 'uint24',
        name: 'fees',
        type: 'uint24',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'minPrediction',
    outputs: [
      {
        internalType: 'uint160',
        name: 'minPredictionValue',
        type: 'uint160',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'pause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'paused',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: 'marketId',
        type: 'uint32',
      },
      {
        internalType: 'uint8',
        name: 'outcomeIndex',
        type: 'uint8',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minShares',
        type: 'uint256',
      },
    ],
    name: 'placePrediction',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'platformFees',
    outputs: [
      {
        internalType: 'uint256',
        name: 'fees',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'platformFeesBalance',
    outputs: [
      {
        internalType: 'uint256',
        name: 'balance',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'predictionCurrency',
    outputs: [
      {
        internalType: 'address',
        name: 'currency',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'predictionsCount',
    outputs: [
      {
        internalType: 'uint32',
        name: 'count',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'predictionsCountPerUser',
    outputs: [
      {
        internalType: 'uint32',
        name: 'count',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'recoverEth',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'url',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'logoUrl',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'description',
        type: 'bytes32',
      },
    ],
    name: 'registerAffiliate',
    outputs: [
      {
        internalType: 'uint32',
        name: 'affiliateId',
        type: 'uint32',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'nickName',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'streamUrl',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'description',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'metadataUri',
        type: 'bytes32',
      },
    ],
    name: 'registerCreator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_adminFacet',
        type: 'address',
      },
    ],
    name: 'setAdminFacet',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_affiliateFacet',
        type: 'address',
      },
    ],
    name: 'setAffiliateFacet',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint24',
        name: 'percentage',
        type: 'uint24',
      },
    ],
    name: 'setAffiliateFeePercentage',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'status',
        type: 'bool',
      },
    ],
    name: 'setAffiliateStatus',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'beneficiary',
        type: 'address',
      },
    ],
    name: 'setAutoTransferBeneficiary',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'threshold',
        type: 'uint256',
      },
    ],
    name: 'setAutoTransferThreshold',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_creatorFacet',
        type: 'address',
      },
    ],
    name: 'setCreatorFacet',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint24',
        name: 'odds',
        type: 'uint24',
      },
    ],
    name: 'setLowestPossibleOdds',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_marketFacet',
        type: 'address',
      },
    ],
    name: 'setMarketFacet',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint24',
        name: 'fees',
        type: 'uint24',
      },
    ],
    name: 'setMaxFees',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: 'maxMarkets',
        type: 'uint32',
      },
    ],
    name: 'setMaxMarketsPerCreator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint24',
        name: 'time',
        type: 'uint24',
      },
    ],
    name: 'setMaxTime',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint24',
        name: 'fees',
        type: 'uint24',
      },
    ],
    name: 'setMinFees',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint160',
        name: 'amount',
        type: 'uint160',
      },
    ],
    name: 'setMinPredictionAmount',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'fees',
        type: 'uint256',
      },
    ],
    name: 'setPlatformFees',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'currency',
        type: 'address',
      },
    ],
    name: 'setPredictionCurrency',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint24',
        name: 'multiplier',
        type: 'uint24',
      },
    ],
    name: 'setVirtualLiquidityMultiplier',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: 'marketId',
        type: 'uint32',
      },
      {
        internalType: 'uint8',
        name: 'winningOutcomeIndex',
        type: 'uint8',
      },
      {
        internalType: 'bytes32',
        name: 'proof',
        type: 'bytes32',
      },
    ],
    name: 'settleMarket',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'unpause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'url',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'logoUrl',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'description',
        type: 'bytes32',
      },
    ],
    name: 'updateAffiliate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'nickName',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'streamUrl',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'description',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'metadataUri',
        type: 'bytes32',
      },
    ],
    name: 'updateCreator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'virtualLiquidityMultiplier',
    outputs: [
      {
        internalType: 'uint256',
        name: 'multiplier',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'withdrawFees',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
  },
  {
    inputs: [],
    name: 'AffiliateDoesNotExists',
    type: 'error',
  },
  {
    inputs: [],
    name: 'IncorrectAdminParams',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
    ],
    name: 'SafeERC20FailedOperation',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint32',
        name: 'id',
        type: 'uint32',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'status',
        type: 'bool',
      },
    ],
    name: 'UpdatedAffiliate',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint24',
        name: 'percentage',
        type: 'uint24',
      },
    ],
    name: 'UpdatedAffiliateFeePercentage',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'beneficiary',
        type: 'address',
      },
    ],
    name: 'UpdatedAutoTransferBeneficiary',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'threshold',
        type: 'uint256',
      },
    ],
    name: 'UpdatedAutoTransferThreshold',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'currency',
        type: 'address',
      },
    ],
    name: 'UpdatedCurrency',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint24',
        name: 'odds',
        type: 'uint24',
      },
    ],
    name: 'UpdatedLowestPossibleOdds',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint24',
        name: 'maxFees',
        type: 'uint24',
      },
    ],
    name: 'UpdatedMaxFees',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint32',
        name: 'maxMarkets',
        type: 'uint32',
      },
    ],
    name: 'UpdatedMaxMarketsPerCreator',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint24',
        name: 'time',
        type: 'uint24',
      },
    ],
    name: 'UpdatedMaxTime',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint24',
        name: 'minFees',
        type: 'uint24',
      },
    ],
    name: 'UpdatedMinFees',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint160',
        name: 'minPredictionAmount',
        type: 'uint160',
      },
    ],
    name: 'UpdatedMinPredictionAmount',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'platformFees',
        type: 'uint256',
      },
    ],
    name: 'UpdatedPlatformFees',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'multiplier',
        type: 'uint256',
      },
    ],
    name: 'UpdatedVirtualLiquidityMultiplier',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'WithdrawnFees',
    type: 'event',
  },
  {
    inputs: [],
    name: 'AffiliateAlreadyExists',
    type: 'error',
  },
  {
    inputs: [],
    name: 'IncorrectAffiliateDetails',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint32',
        name: 'id',
        type: 'uint32',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'status',
        type: 'bool',
      },
    ],
    name: 'CreatedAffiliate',
    type: 'event',
  },
  {
    inputs: [],
    name: 'CreatorAlreadyExists',
    type: 'error',
  },
  {
    inputs: [],
    name: 'CreatorDoesNotExists',
    type: 'error',
  },
  {
    inputs: [],
    name: 'IncorrectCreatorDetails',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint32',
        name: 'creatorId',
        type: 'uint32',
      },
      {
        indexed: false,
        internalType: 'bytes32',
        name: 'nickname',
        type: 'bytes32',
      },
    ],
    name: 'CreatedCreator',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'currency',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'PaidFee',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint32',
        name: 'creatorId',
        type: 'uint32',
      },
      {
        indexed: false,
        internalType: 'bytes32',
        name: 'nickname',
        type: 'bytes32',
      },
    ],
    name: 'UpdatedCreator',
    type: 'event',
  },
  {
    inputs: [],
    name: 'IncorrectMarketDetails',
    type: 'error',
  },
  {
    inputs: [],
    name: 'IncorrectMarketOutcomeDetails',
    type: 'error',
  },
  {
    inputs: [],
    name: 'IncorrectMarketOutcomeId',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidLowestOddsConfiguration',
    type: 'error',
  },
  {
    inputs: [],
    name: 'LowOddsReachedForOutcome',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MarketCancellationNotAvailable',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MarketSettlementNotAvailable',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MaxMarketsPerCreatorReached',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MaxPredictionCountReached',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MinPredictionNotValid',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NotWithinPredictionPeriod',
    type: 'error',
  },
  {
    inputs: [],
    name: 'PayoutCalculationError',
    type: 'error',
  },
  {
    inputs: [],
    name: 'PayoutTooLargeError',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ReentrancyGuardReentrantCall',
    type: 'error',
  },
  {
    inputs: [],
    name: 'RoundPayoutCalculationError',
    type: 'error',
  },
  {
    inputs: [],
    name: 'SettlerNotCreator',
    type: 'error',
  },
  {
    inputs: [],
    name: 'SharesLessThanMinShares',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint32',
        name: 'id',
        type: 'uint32',
      },
    ],
    name: 'CancelledMarket',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint32',
        name: 'id',
        type: 'uint32',
      },
      {
        indexed: false,
        internalType: 'bytes32',
        name: 'description',
        type: 'bytes32',
      },
      {
        indexed: false,
        internalType: 'uint24',
        name: 'feeBps',
        type: 'uint24',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'minMarketPrediction',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'startTime',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'endTime',
        type: 'uint256',
      },
    ],
    name: 'CreatedMarket',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'currency',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'PaidPrediction',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint32',
        name: 'marketId',
        type: 'uint32',
      },
      {
        indexed: false,
        internalType: 'uint8',
        name: 'outcomeIndex',
        type: 'uint8',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'shares',
        type: 'uint256',
      },
    ],
    name: 'PlacedPrediction',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'wallet',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint32',
        name: 'id',
        type: 'uint32',
      },
      {
        indexed: false,
        internalType: 'uint8',
        name: 'winningOutcomeIndex',
        type: 'uint8',
      },
      {
        indexed: false,
        internalType: 'bytes32',
        name: 'proof',
        type: 'bytes32',
      },
    ],
    name: 'SettledMarket',
    type: 'event',
  },
] as const;

const _bytecode =
  '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';

type FlmFunCoreConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: FlmFunCoreConstructorParams): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class FlmFunCore__factory extends ContractFactory {
  constructor(...args: FlmFunCoreConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(overrides?: NonPayableOverrides & { from?: string }): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      FlmFunCore & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): FlmFunCore__factory {
    return super.connect(runner) as FlmFunCore__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FlmFunCoreInterface {
    return new Interface(_abi) as FlmFunCoreInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): FlmFunCore {
    return new Contract(address, _abi, runner) as unknown as FlmFunCore;
  }
}
